// Pillar enum → display label.
//
// The map exists because naive title-casing of the enum API ID loses the
// ampersands ("Cedar & Wood Science", "Maintenance & Care") and the internal
// capital in "LeisureCraft". It is NOT a gate on which pillars exist: the blog
// filter row derives its tabs from the pillars actually used by articles, so a
// pillar added in Hygraph shows up with no code change. Adding it here only
// upgrades the label from the auto-derived fallback below.
export const PILLAR_LABELS = {
  BUYING_GUIDES: "Buying Guides",
  COMPARISONS: "Comparisons",
  CONTRAST_THERAPY: "Contrast Therapy",
  CEDAR_WOOD_SCIENCE: "Cedar & Wood Science",
  MAINTENANCE_CARE: "Maintenance & Care",
  SAUNA_WELLNESS: "Sauna & Wellness",
  LEISURECRAFT_COMMUNITY: "LeisureCraft Community",
};

// Readable label for a pillar the map has not been taught yet:
// "SOME_NEW_PILLAR" -> "Some New Pillar". Keeps an unmapped value from
// rendering as SCREAMING_SNAKE in the filter row.
function derivedLabel(value) {
  return String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// Label for a pillar value, used by the filter tabs.
export function pillarTabLabel(value) {
  if (!value) return "";
  return PILLAR_LABELS[value] || derivedLabel(value);
}

// Editorial pillarLabel wins; otherwise fall back to the enum label,
// then the derived label as a last resort.
export function pillarLabel(article) {
  if (!article) return "";
  return article.pillarLabel || pillarTabLabel(article.pillar);
}
